import React from 'react'
import { cn, getLeaseMetaValues, getMetaLabelValues } from '~/lib'
import { Listing } from '~/models'

export default function ListingMeta({
  className,
  listing,
}: {
  className?: string
  listing: Listing
}) {
  const meta = listing.meta as { [key: string]: any }

  const renderLeaseMeta = () => {
    const values = getLeaseMetaValues(listing)
    if (values.length === 0) {
      return null
    }
    return (
      <>
        {values.map(({ label, value }, index) => {
          return (
            <React.Fragment key={index}>
              <dt className="col-span-5 py-0.5 text-muted-foreground">
                {label}
              </dt>
              <dd className="col-span-7 py-0.5 text-right font-semibold">
                {value}
              </dd>
            </React.Fragment>
          )
        })}
      </>
    )
  }

  return (
    <dl className={cn(className, 'grid grid-cols-12 text-base')}>
      <>
        {renderLeaseMeta()}
        {getMetaLabelValues(meta).map(({ label, value }, index) => {
          return (
            <React.Fragment key={index}>
              <dt className="col-span-5 py-0.5 text-muted-foreground">
                {label}
              </dt>
              <dd className="col-span-7 py-0.5 text-right font-semibold">
                {value}
              </dd>
            </React.Fragment>
          )
        })}

        <dt className="col-span-5 py-0.5 text-muted-foreground">County</dt>
        <dd className="col-span-7 py-0.5 text-right font-semibold">
          {listing.property.county}
        </dd>
      </>

      <dt className="col-span-5 py-0.5 text-muted-foreground">Created</dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.created.toDateString()}
      </dd>
      <dt className="col-span-5 py-0.5 text-muted-foreground">Updated</dt>
      <dd className="col-span-7 py-0.5 text-right font-semibold">
        {listing.modified.toDateString()}
      </dd>
    </dl>
  )
}
